import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
/**
 * 获取文件夹设置
 *
 * @param {String} space_id
 * @param {String} folder_id
 */
export function getFolderFieldSettingsApi({ space_id, folder_id, view_type = 'tablelist', data_type = 'PATENT' }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/field-setting`,
        method: 'GET',
        params: {
            view_type,
            data_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}
/**
 * 保存文件夹字段设置
 *
 * @param {*} param0
 */
export function putFolderFieldSettingsApi({ space_id, folder_id, folders = [], folder_fields = [], view_type = 'tablelist', data_type = 'PATENT', sync_to_filter, folder_display_fields, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/folder-field-setting`,
        method: 'PUT',
        data: {
            folders,
            folder_fields,
            folder_display_fields,
            view_type,
            data_type,
            sync_to_filter,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}
/**
 * 字段操作
 *
 * @param {*} param0
 */
export function updateFolderFieldSettingsApi({ space_id, folder_id, action, data, sort, data_type = 'PATENT', view_type = 'tablelist' }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/field-setting`,
        method: 'POST',
        data: {
            view_type,
            data_type,
            action,
            data,
            sort,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
